import {
	toProjectKey,
	type IssueKey,
	type ProjectKey,
} from '@atlassian/jira-shared-types/src/general.tsx';

export const extractProjectKey = (issueKey: IssueKey): ProjectKey =>
	toProjectKey(issueKey.split('-')[0]);
